import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EvrakService {
  constructor(private http: HttpClient) {
  }

  // secimId, secimTuru, sandikTuru, yurtIciDisi
  getEvrak(evrakNo, captchaCode, captchaId): Observable<any> {
    const url = environment.APIEndpoint + 'getEvrak';
    return this.http.post<any>(url,
      {
        evrakNo,
        captchaId,
        captchaCode
      }, { responseType: 'blob' as 'json' });
  }
}
